import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

const socketServer = window.socketServer;

if (socketServer?.key) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: socketServer.key,
        wsHost: socketServer.host,
        wsPort: socketServer.port,
        wssPort: socketServer.port,
        cluster: 'eu', // Required by pusher-js but ignored, since wsHost points to the socket server
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        forceTLS: socketServer.forceTLS,
    });
    window.Pusher.logToConsole = import.meta.env.DEV;
} else if (socketServer) {
    console.error('Laravel Echo deactivated. Please configure BROADCAST_CONNECTION=reverb and the REVERB_* variables in .env');
}
